import React, { useEffect, useState } from "react";
import apiService from "./apiService";

const CardComponent = () => {
    const [copied, setCopied] = useState(false);
    const [copiedM10, setCopiedM10] = useState(false);
    const [conditionData, setConditionData] = useState();

    useEffect(() => {
        const fetchConditionData = async () => {
            try {
                const result = await apiService.getSocialLinks(1);
                setConditionData(result);
            } catch (error) {
                console.error('Error fetching condition data:', error);
            }
        };
        fetchConditionData();
    }, []);

    const copyToClipboard = (text, isM10 = false) => {
        navigator.clipboard.writeText(text);
        if (isM10) {
            setCopiedM10(true);
            setTimeout(() => setCopiedM10(false), 2000);
        } else {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-tr from-sky-400 to-violet-500 p-6">
            <div className="bg-white rounded-3xl shadow-2xl p-8 max-w-md w-full relative">
                <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-white rounded-full p-3 shadow-md">
                    <span className="text-3xl">💳</span>
                </div>

                <h2 className="text-center text-2xl font-bold mt-2 text-gray-800">
                    Ödəniş Məlumatları
                </h2>
                <p className="text-center text-gray-600">
                    Oyuna başlamazdan əvvəl aşağıdakı məlumatlarla ödəniş edin və qəbzi bizə göndərin.
                </p>

                <div className="mt-3">
                    <h3 className="text-md text-gray-700 mb-1 font-semibold">Kart Bankının Adı:</h3>
                    <div className="bg-gray-100 px-2 py-1 rounded-lg text-gray-800 font-medium text-center">
                        {conditionData?.cardName || "Yüklənir..."}
                    </div>
                </div>

                <div className="mt-2">
                    <h3 className="text-md text-gray-700 mb-1 font-semibold">Kart Nömrəsi:</h3>
                    <div className="flex items-center justify-between bg-gray-50 border border-gray-300 px-2 py-1 rounded-lg">
                        <span className="font-mono text-lg tracking-wide">{conditionData?.cardNumber}</span>
                        <button
                            onClick={() => copyToClipboard(conditionData?.cardNumber)}
                            className="text-blue-600 hover:text-blue-800 transition"
                        >
                            📋
                        </button>
                    </div>
                    {copied && <p className="text-green-600 text-sm mt-1 text-center animate-pulse">Kopyalandı ✅</p>}
                </div>

                {conditionData?.cardM10 && (
                    <div className="mt-2">
                        <h3 className="text-md text-yellow-800 font-semibold mb-1">🔐 M10 Ödəniş Nömrəsi:</h3>
                        <div className="flex items-center justify-between bg-yellow-50 border border-yellow-300 px-2 py-1 rounded-lg">
                            <span className="font-sans text-base">{conditionData.cardM10}</span>
                            <button
                                onClick={() => copyToClipboard(conditionData.cardM10, true)}
                                className="text-yellow-700 hover:text-yellow-900 transition"
                            >
                                📋
                            </button>
                        </div>
                        {copiedM10 && (
                            <p className="text-green-600 text-sm mt-1 text-center animate-pulse">M10 kopyalandı ✅</p>
                        )}
                    </div>
                )}

                <a
                    href={`https://wa.me/${conditionData?.wpCard}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-3 block w-full bg-green-500 text-white text-center py-3 rounded-xl font-semibold hover:bg-green-600 transition-all"
                >
                    WhatsApp ilə Əlaqə 💬
                </a>
            </div>
        </div>
    );
};

export default CardComponent;
